import { Vector3 } from "three"
import { DirectionalLightConfigDto, BaseLightConfigDto } from "../dto/light-config.dto"
import { LightType } from "../typings/light-type"
import { isDirectionalLight } from "../../../trillion-viewer/src/viewer/utils/type-guards"

export type LightConfig = BaseLightConfig | DirectionalLightConfig

export class BaseLightConfig {
  name = ''
  type: LightType = 'PointLight'
  intensity = 1
  position = new Vector3()
  color: number = 0xffffff

  constructor(lightConfigDto: BaseLightConfigDto) {
    this.name = lightConfigDto.name
    this.type = lightConfigDto.type
    this.intensity = lightConfigDto.intensity
    this.color = lightConfigDto.color
    if (lightConfigDto.position) {
      this.position = new Vector3(
        lightConfigDto.position.x,
        lightConfigDto.position.y,
        lightConfigDto.position.z,
      )
    }
  }
}

export class DirectionalLightConfig extends BaseLightConfig {
  target = new Vector3()

  constructor(lightConfigDto: DirectionalLightConfigDto) {
    super(lightConfigDto)
    if (lightConfigDto.target) {
      this.target = new Vector3(
        lightConfigDto.target.x,
        lightConfigDto.target.y,
        lightConfigDto.target.z,
      )
    }
  }
}

export function isDirectionalLightConfig(lightConfig: LightConfig): lightConfig is DirectionalLightConfig {
  return lightConfig.type === 'DirectionalLight'
}